module.exports = __webpack_public_path__ + "static/media/20240506151348_IMG_6761.014db901.JPG";